import React from 'react';
import { useSelector } from 'react-redux';

import { selectHasThinkingMessages, selectSelectedBot } from '@/store/chat/selectors';

import { Select, Tooltip } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

import { useModelSelection } from '@/contexts/ModelSelectionContext';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import styles from './ModelSelector.module.scss';

const { Option } = Select;

const ModelSelector = ({ size = 'default', disabled = false }) => {
  const selectedBot = useSelector(selectSelectedBot);
  const hasThinkingMessages = useSelector(selectHasThinkingMessages);
  const { selectedModelName, setSelectedModelName } = useModelSelection();

  const isDisabled = disabled || hasThinkingMessages || !selectedBot?.available_models?.length;

  const handleModelChange = modelName => {
    if (!modelName || hasThinkingMessages) {
      return;
    }

    console.log('🔄 Changing model to:', modelName);
    setSelectedModelName(modelName);
  };

  const renderModelOption = model => {
    return (
      <Tooltip title={model.description} placement='topLeft'>
        <div className={styles.modelOption}>
          <div className={styles.modelHeader}>
            <span className={styles.modelName}>
              {model.previewName}
              {model?.pricePerMillionTokens && (
                <span className={styles.priceText}>
                  {Number(model.pricePerMillionTokens).toFixed(2)} ₽ за млн токенов
                </span>
              )}
            </span>
          </div>
        </div>
      </Tooltip>
    );
  };

  if (!selectedBot) {
    return null;
  }
  return (
    <div className={classNames(styles.modelSelector, { [styles.thinking]: hasThinkingMessages })}>
      {' '}
      <Select
        value={selectedModelName}
        onChange={handleModelChange}
        disabled={isDisabled}
        size={size}
        className={styles.select}
        placeholder={selectedBot?.available_models?.length ? 'Выберите модель' : 'Модели недоступны'}
        suffixIcon={hasThinkingMessages ? <LoadingOutlined /> : undefined}
        showSearch={false}
      >
        {selectedBot.available_models?.map(model => (
          <Option key={model.modelId} value={model.modelName}>
            {renderModelOption(model)}
          </Option>
        ))}
      </Select>
    </div>
  );
};

ModelSelector.propTypes = {
  size: PropTypes.oneOf(['small', 'default', 'large']),
  disabled: PropTypes.bool,
};

export default ModelSelector;
